import { Box } from "@mui/material";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import TitreDetailConsult from "./Details/TitreDetaillConsult";
import ReponseDomiciliationBanque from "./Details/ReponseDomiciliationBanque";
import TitreSuiviReglement from "./Details/TitreSuiviReglement";

function TitreDetail(props) {
  const location = useLocation();
  const [isReglement, setIsReglement] = useState(
    location.state?.isReglement || false
  );
  const [isReponse, setIsReponse] = useState(
    location.state?.isReponse || false
  );

  return (
    <Box>
      <Helmet>
        <title>{"Détails Titre - Portail Banques"}</title>
      </Helmet>
      {isReponse === false && isReglement === false && <TitreDetailConsult />}
      {isReglement === true && <TitreSuiviReglement />}
      {isReponse === true && <ReponseDomiciliationBanque />}
    </Box>
  );
}

export default TitreDetail;
